import { right } from "fp-ts/lib/Either";
import Constants, { ConstantsName } from "../../../../../constants/Constants";
import di from "../../../../../di/DependencyInjection";
import callAPI from "../../../fetchCallImplementation";

//TODO implement
const GetAIS3RagPathApiImpl = async (filename: string, customer: string): Promise<any> => {

    let body = {
        filename,
        customer
    }

    const baseUrl = di.get<Constants>(ConstantsName).RAG;

    const url = new URL(`${baseUrl}/generate-upload-url`);

    const response = await callAPI(url.toString(), 'POST', body);
        
    const reader = response.body?.getReader();

    if (!reader) {
        throw new Error("Readable stream not supported or body is empty.");
    }
    
    let result = '';
    const decoder = new TextDecoder();

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        result += decoder.decode(value, { stream: true });
    }

    // Decoding the last chunk
    result += decoder.decode();
    
    return right(result);
}

export default GetAIS3RagPathApiImpl;